import { Box, Flex, Grid, Skeleton } from '@chakra-ui/react';

import { FavoriteButton } from '$/components/core/Collection/FavoriteButton';

export const LoadingMaterialCard = () => {
  return (
    <Box pos='relative' minW='100%' minH='100%'>
      <FavoriteButton aria-label='' />
      <Grid
        templateRows='1fr auto'
        overflow='hidden'
        color='border'
        border='1px solid'
        borderRadius='12px'
        aspectRatio='3/2'
      >
        <Skeleton />
        <Flex
          justify='center'
          gap='3'
          p='2'
          borderTop='1px solid'
          borderTopColor='border'
        >
          <Skeleton w='70%' fontSize='sm'>
            A
          </Skeleton>
        </Flex>
      </Grid>
    </Box>
  );
};
